<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('expedient type management')"
      :columns="columns"
      :column_search="true"
      resource_url="/archive/expedient-type/datatables"
    >
      <template v-slot:buttons>
        <button
          class="button is-secondary is-rounded"
          @click="create_expedient_type"
        >
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>

    <expedient-type-modal
      ref="expedient_type_modal"
      @success="refresh_datatable"
    />
    <expedient-type-detail-modal
      ref="expedient_type_detail_modal"
      @edit="edit_expedient_type"
    />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
} from "@/utils";
import ExpedientTypeModal from "./expedient_type_modal/Index.vue";
import ExpedientTypeDetailModal from "./expedient_type_detail_modal/Index.vue";

export default {
  name: "ExpedientTypesDataTable",
  components: {
    GenericTable,
    "expedient-type-modal": ExpedientTypeModal,
    "expedient-type-detail-modal": ExpedientTypeDetailModal,
  },
  data() {
    return {
      columns: [
        {
          title: this.$t("expedient type name"),
          name: "name",
          searchable: true,
          width: "30%",
          data: (row) => {
            return `<div class="title is-6">${row.name || ""}</div>
                    <div class="subtitle is-7 has-text-grey">${
                      row.description || ""
                    }</div>`;
          },
        },
        {
          title: this.$t("color"),
          name: "color",
          width: "15%",
          data: (row) => {
            return `<span class="tag" style="background-color: ${row.color}; color: white;">
                      ${row.color}
                    </span>`;
          },
        },
        {
          title: this.$t("status"),
          name: "is_active",
          width: "15%",
          data: (row) => {
            return row.is_active
              ? `<span class="tag is-success">${this.$t("active")}</span>`
              : `<span class="tag is-danger">${this.$t("inactive")}</span>`;
          },
        },
        {
          title: this.$t("actions"),
          width: "25%",
          data: (row) => {
            let v = this;
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: function (e) {
                  v.$refs.expedient_type_detail_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.edit_expedient_type(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  v.delete_expedient_type(e.detail.uuid);
                },
              },
            ];
            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create_expedient_type() {
      this.$refs.expedient_type_modal.show_modal();
    },
    edit_expedient_type(uuid) {
      this.$refs.expedient_type_modal.show_modal(uuid);
    },
    delete_expedient_type(uuid) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure delete expedient type"),
        v,
        () => {
          del("/archive/expedient-type", { uuid: uuid })
            .then(() => {
              v.refresh_datatable();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    refresh_datatable() {
      this.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.$refs.datatable.refresh();
  },
};
</script>
